document.addEventListener('DOMContentLoaded', function () {
  const copyBtns = document.querySelectorAll('.js-CopyText');
  
  if (copyBtns.length) {
    copyBtns.forEach(cBtn => cBtn.addEventListener('click', function () {
      const successMessage = document.createElement('span');
      successMessage.classList.add('copy-success-message');

      const copyText = cBtn.dataset.copy;
      navigator.clipboard.writeText(copyText).then(() => {
        successMessage.textContent = 'Скопировано';
      }).catch(() => {
        successMessage.textContent = 'Ошибка';
      }).finally(() => {
        cBtn.append(successMessage);

        setTimeout(() => {
          if (successMessage) {
            successMessage.remove();
          }
        }, 2000);
      });
    }));
  }
});